import React from 'react'

export const NotFound: React.FC = () => {
  return (
    <div style={{ height: '100%', display: 'flex', justifyContent: 'center' }}>
      <p style={{ alignSelf: 'center', fontWeight: 'bold' }}>Page Not Found | ページが存在しません</p>
    </div>
  )
}
